import {
  FLOOR_VIEWER_MESSAGE_TYPES,
  FLOOR_VIEWER_COMMANDS,
  FLOOR_VIEWER_NAVIGATE_KINDS,
  FLOOR_VIEWER_SETTINGS_KINDS,
} from './schema';

export function sanitizeBuilding(building) {
  if (!building || typeof building !== 'object') return null;

  const { floorList, ...rest } = building;

  const safeFloors = Array.isArray(floorList)
    ? floorList.map(floor => {
        if (!floor || typeof floor !== 'object') return null;
        // remove heavy / non‑cloneable runtime fields (three.js objects, textures, etc.)
        const {
          dollHouseCubemapsData,
          doorModelData,
          roomModelData,
          ...safe
        } = floor;
        return safe;
      })
    : null;

  return {
    ...rest,
    floorList: safeFloors,
  };
}

export function getAllowedOrigins() {
  const allowedList =
    process.env.REACT_APP_VIEWER_POSTMESSAGE_ALLOWED_ORIGINS || '';
  const gobizUrl = process.env.REACT_APP_GOBIZEVENT_URL || '';
  const raw = allowedList + ',' + gobizUrl;

  return raw
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
}

export function isTrustedOrigin(origin) {
  if (!origin) return false;
  const allowed = getAllowedOrigins();
  if (allowed.length === 0) return false;
  return allowed.includes(origin);
}

/**
 * Runtime validation for inbound navigate command messages.
 * 僅做格式檢查，不會 throw，適合在 window.message handler 內使用。
 *
 * @param {any} data
 * @returns {boolean}
 */
export function isFloorViewerCommandMessage(data) {
  if (!data || typeof data !== 'object') return false;

  if (data.target !== 'floor-viewer') return false;
  if (data.type !== FLOOR_VIEWER_MESSAGE_TYPES.COMMAND) return false;
  if (
    data.command !== FLOOR_VIEWER_COMMANDS.NAVIGATE &&
    data.command !== FLOOR_VIEWER_COMMANDS.SETTINGS
  ) {
    return false;
  }

  const payload = data.payload;
  if (!payload || typeof payload !== 'object') return false;

  if (data.command === FLOOR_VIEWER_COMMANDS.NAVIGATE) {
    const kinds = Object.values(FLOOR_VIEWER_NAVIGATE_KINDS);
    if (!kinds.includes(payload.kind)) return false;
  }

  if (data.command === FLOOR_VIEWER_COMMANDS.SETTINGS) {
    const kinds = Object.values(FLOOR_VIEWER_SETTINGS_KINDS);
    if (!kinds.includes(payload.kind)) return false;
  }

  if (data.command === FLOOR_VIEWER_COMMANDS.NAVIGATE) {
    switch (payload.kind) {
      case FLOOR_VIEWER_NAVIGATE_KINDS.CHANGE_FLOOR:
        if (
          typeof payload.floorIndex !== 'number' &&
          typeof payload.floorId !== 'string'
        ) {
          return false;
        }
        break;
      case FLOOR_VIEWER_NAVIGATE_KINDS.GOTO_HOTSPOT:
        if (typeof payload.hotspotId !== 'string') return false;
        break;
      case FLOOR_VIEWER_NAVIGATE_KINDS.SET_VIEW:
        if (typeof payload.viewState !== 'string') return false;
        break;
      case FLOOR_VIEWER_NAVIGATE_KINDS.SYNC_FROM_URL:
        if (!payload.query || typeof payload.query !== 'object') return false;
        break;
      default:
        return false;
    }
  }

  if (data.command === FLOOR_VIEWER_COMMANDS.SETTINGS) {
    switch (payload.kind) {
      case FLOOR_VIEWER_SETTINGS_KINDS.CHANGE_LOCALE:
        if (typeof payload.locale !== 'string') return false;
        break;
      default:
        return false;
    }
  }

  return true;
}
